import axios from "axios";
import { useState, useLayoutEffect, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { getAppToken } from "../services/auth";

import {
  getBanks,
  getCustomerAgreementsTokenization,
  getPaymentMethodsByCustomer,
} from "../services/payments";

export const usePayments = ({ setCurrentBrand }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [customerId, setCustomerId] = useState("");
  const [agreementId, setAgreement] = useState("");
  const [existingToken, setExistingToken] = useState(false);
  const [ip, setIp] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [customerAgreements, setCustomerAgreements] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [status, setStatus] = useState([]);

  useLayoutEffect(() => {
    setCustomerId(searchParams.get("c"));
    setAgreement(searchParams.get("a"));
    setCurrentBrand(searchParams.get("b"));
    getIp();

    localStorage.setItem("current_brand", searchParams.get("b"));
  }, []);

  useLayoutEffect(() => {
    if (customerId && agreementId && !existingToken) {
      const interval = setInterval(() => {
        getAuthToken(interval);
      }, 1000);
    }
  }, [customerId, agreementId]);

  const getAuthToken = async (interval) => {
    try {
      const response = await getAppToken();
      if (response.data) {
        localStorage.setItem("access_token_bt", response.data.access_token);
        localStorage.setItem("refresh_token_bt", response.data.access_token);

        clearInterval(interval);
        setExistingToken(true);
      }
    } catch (err) {
      console.error("usePayments:getAuthToken", err);
    }
  };

  useLayoutEffect(() => {
    if (existingToken) {
      fetchData();
    }
  }, [existingToken]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await Promise.all([
        location.pathname !== "/token"
          ? getPaymentMethodsByCustomer(customerId)
          : getCustomerAgreementsTokenization(customerId, agreementId),
        getBanks(1),
      ]);

      if (response[0].data.status === "success") {
        setCustomerAgreements(response[0].data.data);
      } else {
        setStatus(response[0].data.message);
      }
      setBankList(
        response[1].data.data.items.filter((item) => item.status === 1)
      );
    } catch (err) {
      console.error("usePayments:fetchData", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getIp = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIp(res.data.IPv4);
  };

  return {
    customerId,
    agreementId,
    customerAgreements,
    bankList,
    status,
    isLoading,
    ip,
  };
};
